import { render } from "./dialog.vue?vue&type=template&id=bfad5338&scoped=true"
import script from "./dialog.vue?vue&type=script&lang=js"
export * from "./dialog.vue?vue&type=script&lang=js"

import "./dialog.vue?vue&type=style&index=0&id=bfad5338&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-bfad5338"

export default script